import type { TColor } from '$/assets/theme/colors';

export enum SignInStatus {
  LINK_EXPIRED,
  ERROR,
  NO_USER,
  DEFAULT,
}

export type TStatus = {
  header?: {
    color: TColor;
    text: string;
  };
  sub?: {
    color: TColor;
    text: string;
  };
};

const statusMap: { [index in SignInStatus]: TStatus } = {
  [SignInStatus.LINK_EXPIRED]: {
    header: {
      color: 'grey7',
      text: 'Dein Zugangslink ist abgelaufen.',
    },
    sub: {
      color: 'grey7',
      text: 'Wir schicken dir gern einen neuen Link an deine E-Mail-Adresse.',
    },
  },
  [SignInStatus.ERROR]: {
    header: {
      color: 'grey7',
      text: 'Anmeldung',
    },
    sub: {
      color: 'functionalRed',
      text: 'Der Sitzungslink ist ungültig und nach 3 Minuten abgelaufen. Bitte holen Sie sich eine weitere, indem Sie die E-Mail-Adresse eingeben.',
    },
  },
  [SignInStatus.NO_USER]: {
    header: {
      color: 'grey7',
      text: 'Anmeldung',
    },
    sub: {
      color: 'functionalRed',
      text: 'Diese E-Mail-Adresse konnte nicht gefunden werden. ',
    },
  },
  [SignInStatus.DEFAULT]: {
    sub: {
      color: 'grey7',
      text: 'Weiter zu deinem Nutzerkonto',
    },
  },
};
export default statusMap;
